import { Typography } from '@hid-galaxy-ui/galaxy-react';
import { TypographyVariantEnum } from '@hid-galaxy-ui/galaxy-react/components/Typography/typographyEnum';

const PageTitle = ({ children, className = '' }) => {
  return (
    <Typography className={className} variant={TypographyVariantEnum.ProfileHeader}>
      {children}
    </Typography>
  );
};

export default PageTitle;
